"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireWildcard(require("react"));
var _colors = require("../../../constants/colors");
var _spacing = require("../../../constants/spacing");
const MenuGroupText = (0, _styled.default)("div")`
    color: ${_colors.neutralDark20};
    padding: ${_spacing.sizes.medium}px ${_spacing.sizes.medium}px ${_spacing.sizes.xSmall}px;
`;
const Group = (0, _styled.default)("div")`
    display: flex;
    flex-direction: column;
`;
const MenuGroup = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    includeTitle = true,
    text,
    clientId,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Group, {
    role: "group",
    "aria-label": text,
    ref: ref,
    "data-client-id": clientId
  }, includeTitle && /*#__PURE__*/_react.default.createElement(MenuGroupText, (0, _extends2.default)({}, rest, {
    ref: ref,
    "aria-hidden": "true"
  }), text), children);
});
exports.MenuGroup = MenuGroup;
MenuGroup.displayName = "MenuGroup";
//# sourceMappingURL=MenuGroup.js.map